// select2 CJS export is a factory: module.exports = function(root, $) { ... }
// We must call it explicitly to attach $.fn.select2
import select2 from 'select2/dist/js/select2.full.min';
import $ from 'jquery';

if (typeof select2 === 'function') {
  select2($);
}
